module.exports = __webpack_public_path__ + "static/media/bois.28aedb6e.jpg";